import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { updateElementStyles } from '../../utils/style.utils';

@Directive({
    selector: 'ul[sag-ui-tabs-list]'
})
export class TabsListDirective implements OnInit {
    @Input() fullWidth = false;
    @Input() tabsCount = 0;

    constructor(private readonly elementRef: ElementRef<HTMLInputElement>) {}

    ngOnInit(): void {
        if (this.fullWidth) {
            updateElementStyles(this.elementRef, ['grid', '-mb-px'].join(' '));
            this.elementRef.nativeElement.style.gridTemplateColumns = `repeat(${this.tabsCount}, 1fr)`;
            return;
        }

        updateElementStyles(this.elementRef, ['flex', 'flex-wrap', '-mb-px'].join(' '));
    }
}
